/**
 * Created by chenzheyu on 2017/6/12.
 */
import XKcouponSelect from './src/couponSelect.vue'

XKcouponSelect.install = function (Vue) {
  Vue.component(XKcouponSelect.name, XKcouponSelect)
}

export default XKcouponSelect



// WEBPACK FOOTER //
// ./src/components/module/couponSelect/index.js